import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  SignInPageBlueprint,
  ThemeBlueprint,
} from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { TegelModeProvider } from '../components/common/Tegel';
import darkTheme from '../theme/darkTheme';
import apertureTheme from '../theme/myTheme';

export const appModulePresentation = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: () =>
          import('../components/auth/DrivelineSignInPage').then(
            module => module.DrivelineSignInPage,
          ),
      },
    }),
    ThemeBlueprint.make({
      name: 'aperture',
      params: {
        theme: {
          id: 'aperture',
          title: 'Light Mode',
          variant: 'light',
          Provider: ({ children }) => (
            <UnifiedThemeProvider theme={apertureTheme}>
              <TegelModeProvider>{children}</TegelModeProvider>
            </UnifiedThemeProvider>
          ),
        },
      },
    }),
    ThemeBlueprint.make({
      name: 'darkTheme',
      params: {
        theme: {
          id: 'darkTheme',
          title: 'Dark Mode',
          variant: 'dark',
          Provider: ({ children }) => (
            <UnifiedThemeProvider theme={darkTheme}>
              <TegelModeProvider>{children}</TegelModeProvider>
            </UnifiedThemeProvider>
          ),
        },
      },
    }),
  ],
});
